/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const useCountryStates = (countryId, queryParams) => {
  return useQuery({
    queryKey: queryKeys.countryStates.byCountry(countryId),
    queryFn: async () => {
      const response = await fetcher({
        method: "GET",
        url: "/public/countries/states",
        params: { "filter[country_id]": countryId },
      });
      return response.data;
    },
    ...queryParams,
  });
};
